export const countWidthRatioFromHeight = (
  height: number,
  aspectRatio: [number, number]
) => (height * aspectRatio[0]) / aspectRatio[1];
